var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import styles from './index.module.less';
import { WeikeUIPopupLayer } from '@weike/weike-ui';
import { PAGE_MAX_WIDTH } from '@/constants';
var initData = {
    /**
     * @param{number} height 显示区域高度
     */
    height: 0,
    /**
     * @param{number} width 显示区域宽度，最大480
     */
    width: 0,
    /**
     * @param{number} initHeight 默认元素高度
     * @param{number} initViewWidth 默认window宽度
     * @desc 根据不同的屏幕宽度返回 元素响应的高度
     */
    computedSize: function (size, windowWidth) { return size; },
    computedSizePx: function (size, windowWidth) { return size + 'px'; },
};
export var WindowizeContext = React.createContext(initData);
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App(props) {
        var _this = _super.call(this, props) || this;
        _this.computedSize = function (size, initViewWidth) {
            if (initViewWidth === void 0) { initViewWidth = 375; }
            var scale = size / initViewWidth;
            return _this.state.width * scale;
        };
        _this.computedSizePx = function (size, initViewWidth) {
            if (initViewWidth === void 0) { initViewWidth = 375; }
            var scale = size / initViewWidth;
            return _this.state.width * scale + 'px';
        };
        _this.state = initData;
        return _this;
    }
    App.prototype.componentDidMount = function () {
        var _this = this;
        setTimeout(function () {
            _this.setSize();
        }, 250);
        window.addEventListener('resize', function () {
            _this.setSize();
        });
    };
    App.prototype.setSize = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.setState({
                            width: document.body.clientWidth > PAGE_MAX_WIDTH ? PAGE_MAX_WIDTH : document.body.clientWidth,
                            height: document.body.clientHeight,
                            computedSize: this.computedSize,
                            computedSizePx: this.computedSizePx,
                        })];
                    case 1:
                        _a.sent();
                        window.init_width = this.state.width;
                        return [2 /*return*/];
                }
            });
        });
    };
    App.prototype.render = function () {
        return (React.createElement(WindowizeContext.Provider, { value: this.state }, WeikeUIPopupLayer(React.createElement("div", { className: styles.App, "data-stylename": "app" }, this.props.children))));
    };
    return App;
}(React.Component));
export default App;



//////////////////
// WEBPACK FOOTER
// ./src/layout/App/index.tsx
// module id = 205
// module chunks = 41